const theme = {
    light: {
        bg: "#FFFFFF",
        box: {
            default: "#F2F4F6",
            primary: "#E8F3FF"
        },
        text: {
            default: "#212427",
            primary: "#3262D2",
            sub: "#8D94A0"
        }
    },
    dark: {
        bg: "#17171B",
        box: {
            default: "#2C2C36",
            primary: "#423D46"
        },
        text: {
            default: "#FFFFFF",
            primary: "#4884E0",
            sub: "#8D94A0"
        }
    }
}

export default theme